import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
// import { initSentry } from './sentry' // Commenting out Sentry import

const app = createApp(App)
// initSentry(app) // Commenting out Sentry initialization
app.mount('#app')